<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" md="10">
        <v-card elevation="3" class="pa-4 custom-card">
          <v-card-title class="headline text-center">공지사항 {{ isEdit ? '수정' : '작성' }}</v-card-title>
          <v-divider class="mb-4"></v-divider>

          <!-- 제목 -->
          <v-text-field
            v-model="notice_title"
            label="공지 제목"
            outlined
            dense
            class="mb-4"
          />

          <!-- 옵션: 타입 / 활성화 -->
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="notice_type"
                label="공지 타입"
                :items="[{text: '일반', value: 'normal'}, {text: '숨김', value: 'hidden'}]"
                item-text="text"
                item-value="value"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch v-model="is_enabled" label="활성화" inset color="green"></v-switch>
            </v-col>
          </v-row>

          <!-- 본문 에디터 (TinyMCE) -->
          <tiny-editor v-model="notice_message" upload-prefix="project_mandoora/notice/images/" class="mb-4" />

          <v-divider class="mb-4"></v-divider>

          <v-row justify="end">
            <v-spacer></v-spacer>
            <v-btn color="secondary" class="mr-2" @click="CancelEdit">취소</v-btn>
            <v-btn color="primary" :loading="saving" @click="OnSave_EditingData">{{ isEdit ? '수정 완료' : '작성 완료' }}</v-btn>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TinyEditor from '../common/TinyEditor.vue';
import { mandoora_notice } from '../../api/mandoora';

export default {
  name: 'MandooraGameNoticeWrite',
  components: { TinyEditor },
  data() {
    return {
      saving: false,
      notice_title: '',
      notice_message: '',
      notice_type: 'normal',
      is_enabled: true,
    };
  },
  computed: {
    isEdit() {
      return this.$route.query.id !== undefined;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id !== undefined) {
      mandoora_notice.get_notice({ id })
        .then((body) => {
          const data = body && body.result_data ? body.result_data : null;
          if (!data) return;
          this.notice_title = data.title || '';
          this.notice_type = data.notice_type || 'normal';
          this.is_enabled = data.is_enabled !== undefined ? data.is_enabled : true;
          this.notice_message = data.message || '';
        })
        .catch((err) => console.error('[Mandoora NoticeWrite] get_notice', err));
    }
  },
  methods: {
    CancelEdit() {
      this.$router.push('/mandoora/notice');
    },
    async OnSave_EditingData() {
      if (!this.notice_title || !this.notice_title.trim()) {
        alert('제목을 입력해주세요.');
        return;
      }
      const notice_message = this.notice_message || '';
      this.saving = true;
      try {
        if (this.isEdit) {
          await mandoora_notice.set_notice({
            id: this.$route.query.id,
            notice_title: this.notice_title,
            notice_message,
            is_enabled: this.is_enabled,
            notice_type: this.notice_type,
          });
          alert('수정 완료');
        } else {
          await mandoora_notice.create_notice({
            notice_title: this.notice_title,
            notice_message,
            notice_type: this.notice_type,
            is_enabled: this.is_enabled,
            admin_user: localStorage.user_id || 'cms',
          });
          alert('등록 완료');
        }
        this.$router.push('/mandoora/notice');
      } catch (err) {
        console.error('[Mandoora NoticeWrite] save', err);
        alert('저장 실패');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.v-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
.custom-card {
  max-width: 900px;
  margin-top: 30px;
}
</style>
